import { Page } from '@/core/architecture'

import { PostVideoDetailModalTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * PostVideoDetailModal Page
 * Implemented as a practical sample.
 */
export const PostVideoDetailModal: Page = () => {
  const { state, actions } = useViewModel()

  return <PostVideoDetailModalTemplate state={state} {...actions} />
}
